import { render, staticRenderFns } from "./FlightFilters.vue?vue&type=template&id=218c480c&scoped=true&"
import script from "./FlightFilters.vue?vue&type=script&lang=js&"
export * from "./FlightFilters.vue?vue&type=script&lang=js&"
import style0 from "./FlightFilters.vue?vue&type=style&index=0&id=218c480c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218c480c",
  null
  
)

export default component.exports